import React, { useEffect, useState, useCallback } from 'react';
import { GenericTable } from 'components/common/GenericTable';
import { ERRORS_COLUMNS } from 'utils/errorsData';
import { useDispatch, useSelector } from 'react-redux';
import { errorLogsActions } from '_redux/slices/errorLogs.slice';
import { FETCH_ERROR_LOGS } from '_redux/types/errorLogs.types';
import { filesActions } from '_redux/slices/files.slice';
import { GET_FILES } from '_redux/types/files.types';

const Error = ({ handleTabChange, tab, tabs }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  // Selectors
  const errorLogs = useSelector(errorLogsActions.selectors.getErrorLogs);
  const totalErrorLogs = useSelector(
    errorLogsActions.selectors.getTotalErrorLogs
  );
  const files = useSelector(filesActions.selectors.getFiles);
  const selectedFile = useSelector(filesActions.selectors.getSelectedFile);

  // State hooks
  const [selectedFileId, setSelectedFileId] = useState(
    selectedFile || files[0]?.id
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  // Fetch files on component mount
  useEffect(() => {
    dispatch({
      type: GET_FILES,
      payload: {
        limit: 100,
        skip: 0,
      },
    });
  }, [dispatch]);

  // Fetch error logs when pagination or selected file changes
  useEffect(() => {
    dispatch({
      type: FETCH_ERROR_LOGS,
      payload: { limit: rowsPerPage, skip: page * rowsPerPage, selectedFileId },
    });
  }, [dispatch, page, rowsPerPage, selectedFileId, refresh]);

  // Handle file selection change
  const handleSelectedFileChange = useCallback(
    fileId => {
      setSelectedFileId(fileId);
      dispatch(filesActions.actions.setSelectedFile(fileId));
    },
    [dispatch]
  );

  useEffect(() => {
    setData(errorLogs);
  }, [errorLogs]);

  const toggleRefresh = () => {
    setRefresh(prev => !prev);
  };

  return (
    <GenericTable
      title="Error Logs"
      data={data || []}
      columns={ERRORS_COLUMNS}
      pageConfig={{
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        totalRows: totalErrorLogs,
      }}
      handleTabChange={handleTabChange}
      tab={tab}
      isTabs={true}
      tabs={tabs}
      fetchType="errorLogs"
      isFile={true}
      selectedFileId={selectedFileId}
      setSelectedFileId={handleSelectedFileChange}
      setData={setData}
      refreshData={toggleRefresh}
      isErrors={true}
    />
  );
};

export default Error;
